var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonderlicSelectLogoLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "wonderlic_select_logo_light_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 890.822 92.017",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style495"
  }, ".wonderlic_select_logo_light_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#wonderlic_select_logo_light_svg__SVGID_1_)}.wonderlic_select_logo_light_svg__st9{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_select_logo_light_svg__g634",
    transform: "translate(-154.078 -91.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_select_logo_light_svg__g598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_select_logo_light_svg__g596"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.905,
    y1: 26.172,
    x2: 331.038,
    y2: 118.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop497",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop499",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop501",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop503",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st0",
    d: "M316.4 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    id: "wonderlic_select_logo_light_svg__path506",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_1_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000115477440845354756580000004599598214968211887_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.032,
    y1: 44.97,
    x2: 314.165,
    y2: 137.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop508",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop510",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop512",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop514",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.1 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    id: "wonderlic_select_logo_light_svg__path517",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000115477440845354756580000004599598214968211887_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000078733038160102978970000007464873787242260892_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.285,
    y1: 82.565,
    x2: 280.418,
    y2: 174.886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop519",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop521",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop523",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop525",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.6 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    id: "wonderlic_select_logo_light_svg__path528",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000078733038160102978970000007464873787242260892_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000137826293687037762640000009481859442803234746_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.412,
    y1: 101.363,
    x2: 263.544,
    y2: 193.684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop530",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop532",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop534",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop536",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.3 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    id: "wonderlic_select_logo_light_svg__path539",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000137826293687037762640000009481859442803234746_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000116925291430503073590000005451686953658879385_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.588,
    y1: 65.426,
    x2: 294.226,
    y2: 160.057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop541",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop543",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop545",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop547",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.3 181.2c-5.1-3.9-6.1-11.2-2.3-16.4l32.8-44.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-32.8 44.9c-3.8 5.2-10.9 6.2-16 2.4z",
    id: "wonderlic_select_logo_light_svg__path550",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000116925291430503073590000005451686953658879385_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000067943272727003883540000006617168421064286090_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.018,
    y1: 75.338,
    x2: 286.564,
    y2: 168.962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop552",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop554",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop556",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop558",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.1 159.2c-5.1-3.9-6.1-11.2-2.3-16.4l16.7-22.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-16.7 22.9c-3.8 5.2-10.9 6.2-16 2.4z",
    id: "wonderlic_select_logo_light_svg__path561",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000067943272727003883540000006617168421064286090_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000131358935650978663930000008788687210544360366_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.206,
    y1: 107.903,
    x2: 258.016,
    y2: 200.849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop563",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop565",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop567",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop569",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.7 146.6c-5.1-3.9-6.1-11.2-2.3-16.4l7.5-10.3c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-7.5 10.3c-3.7 5.2-10.9 6.2-16 2.4z",
    id: "wonderlic_select_logo_light_svg__path572",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000131358935650978663930000008788687210544360366_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000059305895380690928010000011905505610866700710_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.148,
    y1: 81.593,
    x2: 281.28,
    y2: 173.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop574",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop576",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop578",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop580",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.7 111.1c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    id: "wonderlic_select_logo_light_svg__path583",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000059305895380690928010000011905505610866700710_)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_select_logo_light_svg__SVGID_00000164488024812973671540000003473049744636057775_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.273,
    y1: 113.316,
    x2: 252.955,
    y2: 207.065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "wonderlic_select_logo_light_svg__stop585",
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    id: "wonderlic_select_logo_light_svg__stop587",
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    id: "wonderlic_select_logo_light_svg__stop589",
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    id: "wonderlic_select_logo_light_svg__stop591",
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.8 181.2c-5.1-3.9-6.1-11.2-2.3-16.4l18.5-25.4c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-18.5 25.4c-3.8 5.2-11 6.2-16 2.4z",
    id: "wonderlic_select_logo_light_svg__path594",
    clipRule: "evenodd",
    fill: "url(#wonderlic_select_logo_light_svg__SVGID_00000164488024812973671540000003473049744636057775_)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_select_logo_light_svg__g618"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M344.8 118h6.4l12.2 34 13.5-37.3 13.5 37.3 12.2-34h6.4l-18.6 51.4-13.5-37.3-13.5 37.3z",
    id: "wonderlic_select_logo_light_svg__path600",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M437.1 116.5c13.3 0 24 10.8 24 25.5s-10.8 25.5-24 25.5c-13.3 0-24-10.8-24-25.5s10.7-25.5 24-25.5zm0 44.4c10 0 17.4-8.1 17.4-18.9 0-10.8-7.4-18.9-17.4-18.9-10 0-17.4 8.1-17.4 18.9 0 10.8 7.3 18.9 17.4 18.9z",
    id: "wonderlic_select_logo_light_svg__path602",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M471.5 118h6.6v8.1c2.3-5.2 7.4-8.9 14.5-8.9 10.4 0 16.8 7.3 16.8 18.1V166h-6.6v-29.2c0-8-4.5-13.1-11.8-13.1-7.5 0-12.8 5.4-12.8 13.5v28.7h-6.6V118z",
    id: "wonderlic_select_logo_light_svg__path604",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M542.3 116.5c8.9 0 13.8 4.5 16.1 8.6V99.6h6.6v66.5h-6.6v-7.2c-2.2 4.1-7.2 8.6-16.1 8.6-12.6 0-22.9-10.8-22.9-25.5s10.2-25.5 22.9-25.5zm0 44.4c9.7 0 16.9-8.1 16.9-18.9 0-10.8-7.2-18.9-16.9-18.9-9.3 0-16.2 8.1-16.2 18.9 0 10.8 6.9 18.9 16.2 18.9z",
    id: "wonderlic_select_logo_light_svg__path606",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M575.4 142.2c0-15.6 9.7-25.7 22.6-25.7 12.6 0 20.8 10.7 20.8 23.9 0 0 0 1.6-.1 3.1H582c.4 10.6 6.6 17.4 16.1 17.4 6.5 0 10.1-2.5 13.9-6.7l4.4 4.6c-5.7 6.7-11.7 8.5-18.3 8.5-13.5 0-22.8-9.7-22.8-24.7v-.4zm36.3-4.9c0-7.7-6.1-14.2-13.7-14.2-8.2 0-15.1 6.4-15.5 14.2z",
    id: "wonderlic_select_logo_light_svg__path608",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M628.9 118h6.6v8.1c2.2-5.2 7.1-8.9 13.9-8.9 1 0 2.2.1 2.8.2v7.6c-1.1-.3-2.6-.5-4.5-.5-7 0-12.2 5.4-12.2 13.5v28h-6.6z",
    id: "wonderlic_select_logo_light_svg__path610",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M663.6 99.6h6.6v53.9c0 5.2 1.4 7.4 5.7 7.4 1.1 0 2.2-.1 3.2-.4v6.6c-1.1.3-2.2.4-3.2.4-4.8 0-12.3-1.1-12.3-13.5z",
    id: "wonderlic_select_logo_light_svg__path612",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M686.5 105.2c0-2.8 2.2-4.8 4.5-4.8s4.5 2 4.5 4.8-2.2 4.8-4.5 4.8-4.5-2.1-4.5-4.8zm1.2 12.8h6.6v48.1h-6.6z",
    id: "wonderlic_select_logo_light_svg__path614",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M728.8 116.5c6.8 0 12.7 2.5 17.1 7.3l-4 5c-3.4-3.7-8-5.6-13.1-5.6-10 0-17.4 8.1-17.4 18.9 0 10.8 7.4 18.9 17.4 18.9 5.1 0 9.7-1.9 13.1-5.6l4 5c-4.4 4.8-10.3 7.3-17.1 7.3-13.3 0-24-10.8-24-25.5 0-14.9 10.8-25.7 24-25.7z",
    id: "wonderlic_select_logo_light_svg__path616",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_select_logo_light_svg__g632"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M782.4 165.9c-3.5-1.5-6.3-3.7-8.4-6.5-2.1-2.8-3.1-6.2-3.2-10h13.6c.2 2.6 1.1 4.6 2.8 6.2 1.7 1.5 3.9 2.3 6.8 2.3 3 0 5.3-.7 7-2.1 1.7-1.4 2.5-3.3 2.5-5.6 0-1.9-.6-3.4-1.7-4.6-1.1-1.2-2.6-2.2-4.3-2.9-1.7-.7-4.1-1.5-7.1-2.3-4.1-1.2-7.4-2.4-10-3.6-2.6-1.2-4.8-3-6.6-5.3-1.8-2.4-2.8-5.6-2.8-9.5 0-3.7.9-7 2.8-9.8 1.9-2.8 4.5-4.9 7.9-6.4 3.4-1.5 7.2-2.2 11.6-2.2 6.5 0 11.8 1.6 15.9 4.8 4.1 3.2 6.3 7.6 6.7 13.3H802c-.1-2.2-1-4-2.8-5.4-1.7-1.4-4-2.1-6.8-2.1-2.5 0-4.4.6-5.9 1.9-1.5 1.3-2.2 3.1-2.2 5.5 0 1.7.6 3.1 1.7 4.2s2.5 2 4.2 2.7c1.7.7 4 1.5 7 2.4 4.1 1.2 7.4 2.4 10 3.6 2.6 1.2 4.8 3 6.7 5.4 1.9 2.4 2.8 5.6 2.8 9.5 0 3.4-.9 6.5-2.6 9.4-1.8 2.9-4.3 5.2-7.7 6.9-3.4 1.7-7.4 2.6-12 2.6-4.5-.1-8.4-.9-12-2.4z",
    id: "wonderlic_select_logo_light_svg__path620",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M873.9 146.3h-36.6c.3 3.6 1.6 6.5 3.8 8.5 2.2 2.1 5 3.1 8.2 3.1 4.7 0 8.1-2 10-6.1H873c-1.4 4.8-4.2 8.8-8.3 11.9-4.1 3.1-9.1 4.7-15.1 4.7-4.8 0-9.2-1.1-13-3.2-3.8-2.1-6.8-5.2-9-9.1-2.1-3.9-3.2-8.4-3.2-13.6 0-5.2 1.1-9.7 3.2-13.7 2.1-3.9 5.1-6.9 8.9-9 3.8-2.1 8.2-3.2 13.1-3.2 4.8 0 9 1 12.8 3.1 3.8 2.1 6.7 5 8.8 8.7 2.1 3.8 3.1 8.1 3.1 13-.1 1.8-.2 3.4-.4 4.9zm-12.8-8.5c-.1-3.3-1.2-5.9-3.5-7.8-2.3-2-5.1-2.9-8.4-2.9-3.1 0-5.8 1-7.9 2.8-2.1 1.9-3.5 4.5-3.9 7.9z",
    id: "wonderlic_select_logo_light_svg__path622",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M896.1 100.6v67h-12.7v-67z",
    id: "wonderlic_select_logo_light_svg__path624",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M954.9 146.3h-36.6c.3 3.6 1.6 6.5 3.8 8.5 2.2 2.1 5 3.1 8.2 3.1 4.7 0 8.1-2 10-6.1H954c-1.4 4.8-4.2 8.8-8.3 11.9-4.1 3.1-9.1 4.7-15.1 4.7-4.8 0-9.2-1.1-13-3.2-3.8-2.1-6.8-5.2-9-9.1-2.1-3.9-3.2-8.4-3.2-13.6 0-5.2 1.1-9.7 3.2-13.7 2.1-3.9 5.1-6.9 8.9-9 3.8-2.1 8.2-3.2 13.1-3.2 4.8 0 9 1 12.8 3.1 3.8 2.1 6.7 5 8.8 8.7 2.1 3.8 3.1 8.1 3.1 13-.1 1.8-.2 3.4-.4 4.9zm-12.8-8.5c-.1-3.3-1.2-5.9-3.5-7.8-2.3-2-5.1-2.9-8.4-2.9-3.1 0-5.8 1-7.9 2.8-2.1 1.9-3.5 4.5-3.9 7.9z",
    id: "wonderlic_select_logo_light_svg__path626",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M964.4 128.9c2.1-3.9 5-6.9 8.8-9 3.7-2.1 8-3.2 12.8-3.2 6.2 0 11.4 1.6 15.4 4.7 4.1 3.1 6.8 7.5 8.2 13.1h-13.7c-.7-2.2-1.9-3.9-3.7-5.1-1.7-1.2-3.8-1.9-6.4-1.9-3.6 0-6.5 1.3-8.6 3.9-2.1 2.6-3.2 6.3-3.2 11.2 0 4.8 1.1 8.5 3.2 11.1 2.1 2.6 5 3.9 8.6 3.9 5.1 0 8.5-2.3 10-6.9h13.7c-1.4 5.4-4.1 9.7-8.2 12.9-4.1 3.2-9.2 4.8-15.4 4.8-4.8 0-9.1-1.1-12.8-3.2-3.7-2.1-6.7-5.2-8.8-9-2.1-3.8-3.2-8.4-3.2-13.6.1-5.3 1.1-9.8 3.3-13.7z",
    id: "wonderlic_select_logo_light_svg__path628",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_select_logo_light_svg__st9",
    d: "M1033.7 127.8V152c0 1.7.4 2.9 1.2 3.7.8.8 2.2 1.1 4.1 1.1h5.9v10.7h-8c-10.7 0-16-5.2-16-15.6v-24.2h-6v-10.4h6V105h12.8v12.4h11.2v10.4z",
    id: "wonderlic_select_logo_light_svg__path630",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonderlicSelectLogoLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonderlic_select_logo_light.682d68b871d3798b99a6b2d8c3939fa5.svg";